<template>
  <div id="logo">
    <!--<img src="../assets/logo.svg" />-->
  </div>
</template>

<script>

export default {
  name: 'logo'
}

</script>

<style scoped>
#logo {
  position: absolute;
  top: 40px;
  left: 50px;
  z-index: 4;
}

@media only screen and (max-width: 768px) {
  #logo {
    top: 30px;
    left: 20px;
  }

  #logo img {
    height: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// Logo.vue?4a16e8f6